module.exports = __webpack_public_path__ + "assets/images/tri_r.846067da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/tri_r.png
// module id = 772
// module chunks = 1